enum ObjectExistsStatus {
  IsNew = 1,
  IsActive = 2,
  IsDeleted = 3,
}

export default ObjectExistsStatus;
